import React, { useEffect, useState } from 'react';
import { Modal, View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import MyAppText from '../../../components/MyAppText';
import FormActions from '../../../components/FormActions';
import { translate } from '../../../services/translate';
import { useQuery } from '@tanstack/react-query';
import { crmService } from '../../../services/central-api/crm';

interface Props {
    onClose: () => void;
    isModalVisible: boolean;
    observation: string;
    reason?: TicketReason;
    formSubmit: () => Promise<void>;
    ticketId: number;
}

export default function EmailPreviewModal({ onClose, isModalVisible, observation, reason, formSubmit, ticketId }: Props) {
    const { styles } = useStyles(styleSheet);

    const [content, setContent] = useState('');

    const { data } = useQuery({
        queryKey: ['getCameraSlaTemplate', ticketId],
        queryFn: () => crmService.getCameraSlaTemplate(ticketId),
        enabled: !!ticketId,
    });


    useEffect(() => {
        if (isModalVisible && data) {
            setContent(data.htmlContent.replaceAll('{{observation}}', `O cenário DRP ${reason?.name} foi adicionado ao ticket #${ticketId}.<br>${observation.replaceAll('\n', '<br>')}`));
        }
    }, [isModalVisible, data]);

    return (
        <Modal
            transparent={true}
            visible={isModalVisible}
            animationType='fade'
            onRequestClose={() => onClose()}
        >
            <View style={styles.container}>
                <View style={styles.formContainer}>
                    <MyAppText style={{ fontSize: 20 }}>{translate('reviewEmailInfo')}</MyAppText>

                    <iframe
                        title="Email preview"
                        srcDoc={content}
                        style={{
                            width: '100%',
                            height: '600px',
                            border: '1px solid #ddd',
                            borderRadius: 8,
                            background: '#fff',
                        }}
                    />

                    <FormActions
                        onSubmit={formSubmit}
                        onClose={() => onClose()}
                        disabled={false}
                        confirmText={'send'}
                    />
                </View>
            </View>
        </Modal>
    );
}

const styleSheet = createStyleSheet((theme) => ({
    container: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#31313199',
        flex: 1
    },
    formContainer: {
        width: 800,
        minHeight: 150,
        backgroundColor: theme.colors.container.background,
        borderRadius: 4,
        padding: 20,
        rowGap: 25,
        justifyContent: 'space-between'
    },
}));
